import { styled } from "@mui/material/styles";
import MuiListItemIcon from "@mui/material/ListItemIcon";
import MuiListItemText from "@mui/material/ListItemText";
import WrapTextIcon from "@mui/icons-material/WrapText";

export const ListItemIcon = styled(MuiListItemIcon)(() => ({
  minWidth: "30px",
  justifyContent: "center",
  "& svg": {
    fontSize: "18px !important",
    color: "#1E283E"
  }
}));

export const ListItemText = styled(MuiListItemText)(() => ({
  "& .MuiListItemText-primary": {
    fontSize: "13px",
    fontWeight: "normal",
    padding: "0 8px"
  }
}));

export const WrapIcon = styled(WrapTextIcon)(() => ({
  "& .MuiListItemText-primary": {
    fontSize: "13px",
    fontWeight: "normal",
    padding: "0 8px"
  }
}));
